import { cache } from 'react';

import { getPublicEnvironmentVariables } from '../helpers/get-public-environment-variables';
import { fetchWithErrorHandling } from '../http-services/fetch-with-error-handling';
import { type State } from '../types/state';
import { OrgSharedDataTag } from './constants/tags';

export const getCountryStates = cache(async (countryId: Nullable<number>) => {
  const environment =
    typeof window === 'undefined' ? await getPublicEnvironmentVariables() : window.PUBLIC_ENV;

  return await fetchWithErrorHandling<State[]>(
    `${environment.apiBaseUrl}/${environment.profileRoute}/States/${countryId}`,
    {
      headers: {
        'Ocp-Apim-Subscription-Key': environment.ocpApiSubscriptionKey ?? '',
      },
      next: {
        tags: [
          OrgSharedDataTag.GET_COUNTRY_STATES,
          `${OrgSharedDataTag.GET_COUNTRY_STATES}_${countryId}`,
        ],
      },
    }
  );
});
